import * as React from "react";
import CollectionPreferences from "@cloudscape-design/components/collection-preferences";

const PAGE_SIZE_OPTIONS = [
    {value: 10, label: '10 Calls'},
    {value: 50, label: '50 Calls'},
    {value: 100, label: '100 Calls'},
]

const VISIBLE_CONTENT_OPTIONS = [{
    label: 'Call list properties',
    options: [
        {id: "status", label: "Status", visible: false},
        {id: "userName", label: "User Name", visible: true},
        {id: "group", label: "Group", visible: true},
        {id: "date", label: "Date", visible: true},
        {id: "summary_summary", label: "Summary", visible: true},
        {id: "callerSentimentScore", label: "Cust Sentiment", visible: true},
        {id: "duration", label: "Duration", visible: true},
    ]
}];

export const DEFAULT_PREFERENCES = {
    pageSize: 30,
    wrapLines: false,
    stripedRows: false,
    contentDensity: 'comfortable',
    /* stickyColumns: { first: 0, last: 0 },*/
    visibleContent: [
        'userName',
        'group',
        'call_timestamp',
        'date',
        'summary_summary',
        'callerSentimentScore',
        'duration',
        'apptFirm',
        'speaking',
        'dealerNameAcc',
        'selfConfidence',
        'objectionsHandling',
        'activeListening',
        'fillerWords',
        'usageOfTitles',
        'appreciationWordCount',
        'voicemail'
    ]
};

export const ContactTablePreferences = ({
                                            preferences,
                                            setPreferences,
                                            disabled,
                                            pageSizeOptions = PAGE_SIZE_OPTIONS,
                                            visibleContentOptions = VISIBLE_CONTENT_OPTIONS,
                                        }) => (
    <CollectionPreferences
        title="Preferences"
        confirmLabel="Confirm"
        cancelLabel="Cancel"
        onConfirm={({detail}) => setPreferences(detail)}
        preferences={preferences}
        disabled={disabled}
        stickyColumnsPreference={{}}
        /*pageSizePreference={{
          title: "Page Size",
          options: pageSizeOptions
        }}*/
        wrapLinesPreference={{
            label: 'Wrap lines',
            description: 'Check to see all the text and wrap the lines',
        }}
        visibleContentPreference={{
            title: 'Select visible columns',
            options: visibleContentOptions,
        }}
    />
);
